/* eslint-disable no-empty-pattern */
import {call, put, select} from 'redux-saga/effects'
import {push} from 'connected-react-router'
import PermissionsActions, {PermissionsSelectors} from '../Redux/PermissionsRedux'
import AuthActions from '../Redux/AuthRedux'
import ErrorsActions from '../Redux/ErrorsRedux'

export function* getPermissions(api, authApi, {page, page_size, filter}) {
  try {
    const response = yield call(api.getPermissions, page, page_size, filter)
    if (response && response.ok) {
      yield put(PermissionsActions.permissionsSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(PermissionsActions.permissionsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getPermissions(api, authApi, {page, page_size, filter})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(PermissionsActions.permissionsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* getPermission(api, authApi, {id}) {
  try {
    const response = yield call(api.getPermission, id)
    if (response && response.ok) {
      yield put(PermissionsActions.permissionSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(PermissionsActions.permissionsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getPermission(api, authApi, {id})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(PermissionsActions.permissionsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* savePermissions(api, authApi, {data}) {
  try {
    const response = yield call(api.savePermissions, data)
    let state = yield select(PermissionsSelectors.getState)
    if (response && response.ok) {
      yield put(PermissionsActions.savePermissionsSuccess(response.data))
      if (data.id) {
        yield put(PermissionsActions.permissionsRequest(state.page, state.page_size, {pages: state.filter?.length ? state.filter : null}))
      } else {
        yield put(PermissionsActions.permissionsRequest(1, state.page_size, {pages: state.filter?.length ? state.filter : null}))
      }
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(PermissionsActions.permissionsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* savePermissions(api, authApi, {data})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(PermissionsActions.permissionsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* deletePermissions(api, authApi, {id}) {
  try {
    const response = yield call(api.deletePermissions, id)
    let state = yield select(PermissionsSelectors.getState)
    if (response && response.ok) {
      yield put(PermissionsActions.deletePermissionsSuccess(true, id))
      yield put(PermissionsActions.permissionsRequest(1, state.page_size, {pages: state.filter?.length ? state.filter : null}))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(PermissionsActions.permissionsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* deletePermissions(api, authApi, {id})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(PermissionsActions.permissionsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* getPermissionsPages(api, authApi, {}) {
  try {
    const response = yield call(api.getPermissionsPages)
    if (response && response.ok) {
      yield put(PermissionsActions.permissionsPagesSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(PermissionsActions.permissionsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getPermissionsPages(api, authApi, {})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(PermissionsActions.permissionsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}
